import { DiscountedPrice } from '@/components/base/discounted-price/discounted-price';
import Divider from '@/components/base/divider/divider';
import Skeleton from '@/components/base/skeleton/skeleton';
import TextSkeleton from '@/components/base/skeleton/text-skeleton';
import { Link } from '@/navigation';
import { clsx } from 'clsx';
import Image from 'next/image';

interface Props {
  image: string;
  title: string;
  price: string;
  discountedPrice?: string;
  url: string;
  prefetch?: boolean | null;
}

const { container, imageWrapper, textWrapper } = {
  container: 'grid w-full grid-cols-[72px_1fr] gap-xs py-xs',
  imageWrapper: 'relative h-xl w-[72px] overflow-hidden rounded-s',
  textWrapper: 'flex flex-col gap-xxs',
};

export const Product = ({
  url,
  price,
  title,
  image,
  discountedPrice,
  prefetch = null,
}: Props) => {
  return (
    <Link
      prefetch={prefetch}
      href={url}
      aria-label={title}
      className="block h-full w-full"
    >
      <div className={container}>
        <div className={clsx(imageWrapper, 'bg-decorative')}>
          <Image
            src={image}
            alt={title}
            width={72}
            height={54}
            sizes="72px"
            className="h-full w-full"
          />
        </div>
        <div className={textWrapper}>
          <p className="text-body">{title}</p>
          <DiscountedPrice
            price={discountedPrice ? +discountedPrice : +price}
            priceBeforeDiscount={discountedPrice ? +price : null}
            wrapperClassName="flex items-center gap-xxs"
          />
        </div>
      </div>
      <Divider />
    </Link>
  );
};

const ProductSkeleton = () => {
  return (
    <>
      <div className={container}>
        <Skeleton className={imageWrapper} />
        <div className={textWrapper}>
          <TextSkeleton className="w-1/2" />
          <TextSkeleton className="w-clickable-minimum" />
        </div>
      </div>
      <Divider />
    </>
  );
};

Product.Skeleton = ProductSkeleton;
